import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class Menu extends BaseClass {
  Download: boolean;
  Upload: boolean;
  ManageAllergens: boolean;
  constructor(obj: any = PERMISSIONS.Menu) {
    super(obj);
    this.Download = !!obj?.Download;
    this.Upload = !!obj?.Upload;
    this.ManageAllergens = !!obj?.ManageAllergens;
  }
}
